import { FC, MouseEvent, useState } from 'react';
import { logModalDialogOpened } from 'services/analytics';
import { ReactComponent as BushfireWarningIcon } from '../../assets/icons/icon-bushfire-warning-system-transparent.svg';
import { ReactComponent as FireIcon } from '../../assets/icons/icon-fire-transparent.svg';
import BushfireWarningCarousel from '../bushfire-warning-carousel';
import FireDangerCarousel from '../fire-danger-carousel';
import InfographicDialog from '../infographic-dialog';
import { DialogLink } from '../questions/question.styles';
import {
  ContentWrapper,
  TitleText,
  WarningCardStyled,
} from './warning-systems-card.styles';
const WarningSystemsCard: FC = () => {
  const [showBushfireWarningDialog, setShowBushfireWarningDialog] =
    useState(false);
  const [showFireDangerDialog, setShowFireDangerDialog] = useState(false);

  const openBushfireWarningDialog = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    setShowBushfireWarningDialog(true);
    logModalDialogOpened(undefined, 'bushfire_warning_levels');
  };

  const openFireDangerDialog = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    setShowFireDangerDialog(true);
    logModalDialogOpened(undefined, 'fire_danger_ratings');
  };

  const closeBushfireWarningDialog = () => setShowBushfireWarningDialog(false);
  const closeFireDangerDialog = () => setShowFireDangerDialog(false);

  return (
    <>
      <WarningCardStyled>
        <TitleText>
          Know the essential information that will keep you safe.
        </TitleText>
        <DialogLink href='/' onClick={openFireDangerDialog}>
          <ContentWrapper>
            <FireIcon />
            <span>What are fire danger ratings?</span>
          </ContentWrapper>
        </DialogLink>
        <DialogLink href='/' onClick={openBushfireWarningDialog}>
          <ContentWrapper>
            <BushfireWarningIcon />
            <span>What is the bushfire warning system?</span>
          </ContentWrapper>
        </DialogLink>
      </WarningCardStyled>
      <InfographicDialog
        showDialog={showBushfireWarningDialog}
        closeDialog={closeBushfireWarningDialog}
      >
        <BushfireWarningCarousel />
      </InfographicDialog>
      <InfographicDialog
        showDialog={showFireDangerDialog}
        closeDialog={closeFireDangerDialog}
      >
        <FireDangerCarousel />
      </InfographicDialog>
    </>
  );
};

export default WarningSystemsCard;
